// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { InvoiceSummaryModel } from "@store/Framework/Services/Reporting/ReportingModels";
import { InvoiceDetail } from "@store/Framework/Types/types";
import { Draft } from "immer";

export type InvoiceDetailState = Toolkit.Store.Bunzl.Pages.InvoiceDetail.State;
export type ReportAPIState = Toolkit.Store.Bunzl.Pages.ReportAPI.State;
export type InvoiceSummaryState = Toolkit.Store.Bunzl.Pages.ReportInvoiceSummary.State;

export const initialInvoiceSummaryState: InvoiceSummaryState = {
    invoiceSummaryReportData: undefined,
};

const initialInvoiceDetailState: InvoiceDetailState = {};

const initialReportAPIState: ReportAPIState = {
    poError: false,
    validationError: false,
};

export const invoiceDetailActions = {
    "Store/Pages/invoiceDetail/LoadInvoiceDetail": (
        draft: Draft<InvoiceDetailState>,
        action: { report: InvoiceDetail },
    ) => {
        draft.invoiceDetailReportData = action.report;
    },
};

export const reportAPIActions = {
    "Store/Pages/reportAPI/setPoError": (draft: Draft<ReportAPIState>, action: { action: boolean }) => {
        draft.poError = action.action;
    },
    "Store/Pages/reportAPI/setValidationError": (draft: Draft<ReportAPIState>, action: { action: boolean }) => {
        draft.validationError = action.action;
    },
};

export const invoiceSummarysactions = {
    "Store/Pages/invoiceSummarys/LoadInvoiceSummary": (
        draft: Draft<InvoiceSummaryState>,
        action: { report: InvoiceSummaryModel },
    ) => {
        draft.invoiceSummaryReportData = action.report;
    },
};

const invoiceDetailReducer = createTypedReducerWithImmer(initialInvoiceDetailState, invoiceDetailActions);
const reportAPIReducer = createTypedReducerWithImmer(initialReportAPIState, reportAPIActions);
const invoiceSummaryReducer = createTypedReducerWithImmer(initialInvoiceSummaryState, invoiceSummarysactions);
export type InvoiceDetailActions = Parameters<typeof invoiceSummaryReducer>[1];
export type ReportAPIactions = Parameters<typeof reportAPIReducer>[1];
export type InvoiceSummaryActions = Parameters<typeof invoiceSummaryReducer>[1];
export default { reportAPIReducer, invoiceSummaryReducer, invoiceDetailReducer };
